<template>
  <el-dialog :visible="show" @close="closeModal">
    <ModalHeader slot="title" title="Thay đổi credit tài khoản" icon="fas fa-pen-nib" />
    <el-form v-if="user" :model="form" ref="resetPasswordForm" :hide-required-asterisk="true">
      <h5 class="text-center">Thay đổi credit tài khoản "{{ user.email }}"</h5>
      <br />
      <el-row>
        <h5>Số lượt kiểm tra</h5>
        <el-col :span="8">
          Số lượt hiện tại
          <br/>
          <el-input-number v-model="form.checkAttempt.current" disabled/>
        </el-col>
        <el-col :span="8">
          Tăng/giảm số lượt
          <br/>
          <el-input-number v-model="form.checkAttempt.delta" @change="changeAttemptDelta" :min="-form.checkAttempt.current"/>
        </el-col>
        <el-col :span="8">
          Số lượt sau thay đổi
          <br/>
          <el-input-number v-model="form.checkAttempt.final" @change="changeAttemptFinal" :min="0" :max="999999"/>
        </el-col>
      </el-row>
      <br/>
      <el-row>
        <h5>Số trang kiểm tra</h5>
        <el-col :span="8">
          Số trang hiện tại
          <br/>
          <el-input-number v-model="form.credit.current" disabled/>
        </el-col>
        <el-col :span="8">
          Tăng/giảm số trang
          <br/>
          <el-input-number v-model="form.credit.delta" @change="changeCreditDelta" :min="-form.credit.current"/>
        </el-col>
        <el-col :span="8">
          Số trang sau thay đổi
          <br/>
          <el-input-number v-model="form.credit.final" @change="changeCreditFinal" :min="0" :max="999999"/>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeModal">Trở về</el-button>
      <CommonButton type="primary" @click="onSubmit" :ref="refs.CONFIRM_BUTTON">Thay đổi</CommonButton>
    </span>
  </el-dialog>
</template>

<script>
  import {updateCredit, updateSubscription} from '@/services/user_service.js'
import ModalHeader from '@/components/common/ModalHeader.vue'
import CommonButton from '@/components/common/CommonButton.vue'
import { apiGetAllPricingPlan } from '@/services/pricing_plan_service.js'

export default {
  name: 'EditUserCreditModal',
  components: { ModalHeader, CommonButton },
  data() {
    return {
      show: false,
      user: true,
      form: {
        checkAttempt: {
          current: 0,
          delta: 0,
          final: 0
        },
        credit: {
          current: 0,
          delta: 0,
          final: 0
        },
      },
      refs: {
        CONFIRM_BUTTON: 'CONFIRM_BUTTON',
      },
    }
  },
  methods: {
    showModal(user) {
      this.user = user
      this.show = true
      this.form.checkAttempt.current = user.credit.checkAttempt
      this.form.checkAttempt.delta = 0
      this.form.checkAttempt.final = user.credit.checkAttempt
      this.form.credit.current = user.credit.credit
      this.form.credit.delta = 0
      this.form.credit.final = user.credit.credit
    },
    closeModal() {
      this.show = false
    },
    changeAttemptDelta(currentValue, oldValue){
      this.form.checkAttempt.delta = currentValue
      this.form.checkAttempt.final = this.form.checkAttempt.current + currentValue
    },
    changeAttemptFinal(currentValue, oldValue){
      this.form.checkAttempt.final = currentValue
      this.form.checkAttempt.delta = currentValue - this.form.checkAttempt.current
    },
    changeCreditDelta(currentValue, oldValue){
      this.form.credit.delta = currentValue
      this.form.credit.final = this.form.credit.current + currentValue
    },
    changeCreditFinal(currentValue, oldValue){
      this.form.credit.final = currentValue
      this.form.credit.delta = currentValue - this.form.credit.current
    },
    async onSubmit() {
      this.$refs[this.refs.CONFIRM_BUTTON].setLoading(true)
      let response = await updateCredit({
        userId: this.user.id,
        checkAttempt: this.form.checkAttempt.final,
        credit: this.form.credit.final,
      })
      if (response) {
        this.$message.success('Cập nhật thành công')
        this.$emit('success')
        this.closeModal()
      } else {
        this.$message.error('Có lỗi xảy ra')
      }
      this.$refs[this.refs.CONFIRM_BUTTON].setLoading(false)
    },
  },
}
</script>

<style scoped></style>
